import { ACTIONS } from '../constants/subscriptions';

const INITIAL_STATE = {
  subscriptionsList: [],
  subscriptionPlanList: [],
  paginator: {},
  error: null,
  loading: false,
  // Ops for single-subscription actions
  activating: false,
  canceling: false,
  // track which specific subscription is in-flight
  activatingId: null,
  cancelingId: null,
  operationError: null,
  lastUpdatedSubscription: null,
  lastRefund: null,
  //  track which user_id the latest subscriptionsList belongs to
  lastFetchedUserId: null,
};

export const subscriptions = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.FETCHING_SUBSCRIPTIONS:
      return { ...state, loading: action.payload };
    case ACTIONS.HANDLE_SUCCESS_GET_SUBSCRIPTIONS: {
      return {
        ...state,
        subscriptionsList: action.payload,
        loading: false,
      };
    }
    case ACTIONS.FETCHING_SUBSCRIPTION_PLANS:
      return { ...state, loading: action.payload };
    case ACTIONS.HANDLE_SUCCESS_GET_SUBSCRIPTION_PLANS: {
      return {
        ...state,
        subscriptionPlanList: action.payload,
        loading: false,
      };
    }

    // --- User: list subscriptions by user id ---
    case ACTIONS.USER_SUBSCRIPTIONS_FETCH_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTIONS.USER_SUBSCRIPTIONS_FETCH_SUCCESS: {
      const payload = action.payload || {};
      const subs = Array.isArray(payload.subscriptions) ? payload.subscriptions : payload;
      const paginator = payload.paginator || payload.pagination || {};
      const userId = payload.user_id || payload.userId || null;
      return {
        ...state,
        subscriptionsList: subs,
        paginator,
        loading: false,
        error: null,
        lastFetchedUserId: userId,
      };
    }
    case ACTIONS.USER_SUBSCRIPTIONS_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || action.error || true,
      };
    case ACTIONS.USER_SUBSCRIPTIONS_FETCH_RESET:
      return {
        ...state,
        subscriptionsList: [],
        paginator: {},
        loading: false,
        error: null,
        lastFetchedUserId: null,
        // also clear any stale operation feedback
        operationError: null,
        lastUpdatedSubscription: null,
        lastRefund: null,
        activating: false,
        canceling: false,
        activatingId: null,
        cancelingId: null,
      };

    // --- User: activate subscription by id ---
    case ACTIONS.USER_SUBSCRIPTION_ACTIVATE_START:
      return {
        ...state,
        activating: true,
        activatingId:
          action.payload && action.payload.subscriptionId ? action.payload.subscriptionId : null,
        operationError: null,
      };
    case ACTIONS.USER_SUBSCRIPTION_ACTIVATE_SUCCESS: {
      const payload = action.payload || {};
      const sub = payload.subscription || payload;
      const list = Array.isArray(state.subscriptionsList) ? state.subscriptionsList : [];
      const updatedList =
        sub && sub.id != null ? list.map(s => (s && s.id === sub.id ? sub : s)) : list;
      return {
        ...state,
        activating: false,
        activatingId: null,
        lastUpdatedSubscription: sub || null,
        subscriptionsList: updatedList,
      };
    }
    case ACTIONS.USER_SUBSCRIPTION_ACTIVATE_FAILURE:
      return {
        ...state,
        activating: false,
        activatingId: null,
        operationError: action.payload || action.error || true,
      };

    // --- User: cancel subscription by id ---
    case ACTIONS.USER_SUBSCRIPTION_CANCEL_START:
      return {
        ...state,
        canceling: true,
        cancelingId:
          action.payload && action.payload.subscriptionId ? action.payload.subscriptionId : null,
        operationError: null,
      };
    case ACTIONS.USER_SUBSCRIPTION_CANCEL_SUCCESS: {
      const payload = action.payload || {};
      const sub = payload.subscription || payload;
      const refund = payload.refund || null;
      const list = Array.isArray(state.subscriptionsList) ? state.subscriptionsList : [];
      const updatedList =
        sub && sub.id != null ? list.map(s => (s && s.id === sub.id ? sub : s)) : list;
      return {
        ...state,
        canceling: false,
        cancelingId: null,
        lastUpdatedSubscription: sub || null,
        lastRefund: refund,
        subscriptionsList: updatedList,
      };
    }
    case ACTIONS.USER_SUBSCRIPTION_CANCEL_FAILURE:
      return {
        ...state,
        canceling: false,
        cancelingId: null,
        operationError: action.payload || action.error || true,
      };

    case ACTIONS.USER_SUBSCRIPTION_OPERATION_FEEDBACK_RESET:
      return {
        ...state,
        operationError: null,
        lastUpdatedSubscription: null,
        lastRefund: null,
      };
    default:
      return state;
  }
};
